import * as React from 'react';

import { trackSubscriptionAuthorBrandInViewport } from './tracking';
import { ElementInViewport } from '../../../common/components/elementInViewport';
import { SubscriptionAuthorBrand } from '../../../components/subscriptionBrand';
import { SubscriptionAuthorActionsContainer } from '../SubscriptionAuthorActions';
import { SubscriptionAuthorAvatarContainer } from '../SubscriptionAuthorAvatar';
import { SubscriptionAuthorDignityContainer } from '../SubscriptionAuthorDignity';
import { SubscriptionAuthorNameContainer } from '../SubscriptionAuthorName';
import { SubscriptionAuthorTitleContainer } from '../SubscriptionAuthorTitle';

export const SubscriptionAuthorBrandContainer = () => {
  const trackIntoView = React.useCallback((isVisible: boolean) => {
    if (!isVisible) {
      return;
    }

    trackSubscriptionAuthorBrandInViewport();
  }, []);

  return (
    <ElementInViewport onChange={trackIntoView}>
      <SubscriptionAuthorBrand
        avatar={<SubscriptionAuthorAvatarContainer />}
        title={<SubscriptionAuthorTitleContainer />}
        name={<SubscriptionAuthorNameContainer />}
        dignity={<SubscriptionAuthorDignityContainer />}
        actions={<SubscriptionAuthorActionsContainer />}
      />
    </ElementInViewport>
  );
};
